module.exports = __webpack_public_path__ + "c5dd949710410a36a3d36fb338aac532.MP3";